const orichiRun2 = () => {
  const price = orichiQuantityProductRes.Price;
  let rules = orichiQuantityProductRes.Rule;
  const setting2 = orichiQuantityProductRes.Setting2;
  const hasDefaultRule = rules.some((rule) => rule.Quantity === 1);
  if (!hasDefaultRule) {
    const defaultRule = {
      Quantity: 1,
      PercentOrPrice: 0,
      PriceType: 1,
    };
    rules = [defaultRule, ...rules];
  }
  const updateTextTotal = (rule, quantity) => {
    const quantityInputValue = quantity || rule.Quantity;
    const newprice = ((price * (100 - rule.PercentOrPrice)) / 100).toFixed(2);
    const totalElement = document.querySelector(".orichi-custom-total");
    const pricePercentSavingsElement = document.querySelector(
      ".orichi-custom-price-percent-savings",
    );
    if (totalElement) {
      const totalPrice = (newprice * quantityInputValue).toFixed(2);
      totalElement.innerHTML = `Total: <span>$${totalPrice}</span>`;
      if (pricePercentSavingsElement) {
        pricePercentSavingsElement.style.opacity =
          rule.PercentOrPrice === 0 ? "0" : "1";
        pricePercentSavingsElement.querySelector("span").textContent =
          rule.PercentOrPrice === 0 ? "" : rule.PercentOrPrice;
      }
    } else {
      const orichiRule = document.querySelector(".orichi .orichi-Rule");
      if (orichiRule) {
        const totalDiv = document.createElement("div");
        totalDiv.className = "orichi-custom-total-container";
        const totalPrice = (newprice * quantityInputValue).toFixed(2);
        totalDiv.innerHTML = `
          <div>
            <p class="orichi-custom-total">Total: <span>$${totalPrice}</span></p>
            <p class="orichi-custom-price-percent-savings" style="opacity: ${rule.PercentOrPrice === 0 ? "0" : "1"}">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 20">
                <path fill="#eb7602" d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z">
                </path>
                <span>${rule.PercentOrPrice}</span>
                % volume discount applied
              </svg>
            </p>
          </div>
        `;
        orichiRule.prepend(totalDiv);
      }
    }
  };
  const handleChangeValueQuantity = (isPlus) => {
    const quantityInputValue =
      Number(document.querySelector(".purchase-details #quantity")?.value) +
      (isPlus ? 1 : -1);
    let selectedRule = rules[0];
    for (let i = 0; i < rules.length; i++) {
      const current = rules[i];
      const next = rules[i + 1];
      if (!next) {
        if (quantityInputValue >= current.Quantity) {
          selectedRule = current;
          break;
        }
      } else {
        if (
          quantityInputValue >= current.Quantity &&
          quantityInputValue < next.Quantity
        ) {
          selectedRule = current;
          break;
        }
      }
    }
    handleClickSlick(selectedRule);
    updateTextTotal(selectedRule, quantityInputValue);
  };
  const handleClickSlick = (rule) => {
    const slickActive = document.querySelector(".orichi-slick-item.active");
    if (slickActive) slickActive.classList.remove("active");
    document
      .querySelector(`#orichi-slick-item-${rule.Quantity}`)
      .classList.add("active");
  };
  const createSlickSlide = (rule, index) => {
    let newPrice = ((price * (100 - rule.PercentOrPrice)) / 100).toFixed(2);
    const quantityStart = rules[index].Quantity;
    const quantityEnd =
      index === rules.length - 1 ? "" : rules[index + 1].Quantity - 1;
    const ruleText =
      quantityStart === quantityEnd
        ? `<p style="font-size: ${setting2.FontSizeItemInTable - 1}px;">Buy ${quantityStart}</p>`
        : index === rules.length - 1
          ? `<p style="font-size: ${setting2.FontSizeItemInTable - 1}px;">Buy ${quantityStart}+</p>`
          : `<p style="font-size: ${setting2.FontSizeItemInTable - 1}px;">Buy ${quantityStart}-${quantityEnd}</p>`;
    const discountText =
      rule.PercentOrPrice > 0 ? `Save ${rule.PercentOrPrice}%` : "";
    const div = document.createElement("div");
    div.innerHTML = `
    <div id="orichi-slick-item-${rule.Quantity}" class="orichi-slick-item">
      ${ruleText}
      <p style="font-size: ${setting2.FontSizeItemInTable - 1}px;">$${newPrice} /unit</p>
      <p class="slick-discount" style="min-height:26px; font-size: ${setting2.FontSizeItemInTable - 1}px;">${discountText}</p>
    </div>
  `;
    div.addEventListener("click", () => {
      const quantityInput = document.querySelector("#quantity");
      quantityInput.value = rule.Quantity;
      handleClickSlick(rule);
      updateTextTotal(rule);
    });
    return div;
  };
  const orichiRule = document.querySelector(".orichi .orichi-Rule");
  if (orichiRule) {
    orichiRule.innerHTML = "";
  }
  const slickContainer = document.createElement("div");
  slickContainer.className = "orichi-slick";
  rules.forEach((rule, index) => {
    slickContainer.appendChild(createSlickSlide(rule, index));
  });
  orichiRule.appendChild(slickContainer);
  const orichiTable = orichiRule.querySelector(".orichi-table");
  if (orichiTable) orichiTable.remove();
  const maxDesktopShow = 4;
  $(slickContainer).slick({
    slidesToShow: Math.min(rules.length, maxDesktopShow),
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    arrows: rules.length > Math.min(rules.length, maxDesktopShow),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(rules.length, 2),
          arrows: rules.length > 2,
        },
      },
    ],
    prevArrow: `
    <span class="orichi-arrow prev">
      <svg width="24" height="24" viewBox="0 0 24 24">
        <polyline points="14,6 8,12 14,18"
          fill="none"
          stroke="currentColor"
          stroke-width="2"/>
      </svg>
    </span>
  `,
    nextArrow: `
    <span class="orichi-arrow next">
      <svg width="24" height="24" viewBox="0 0 24 24">
        <polyline points="10,6 16,12 10,18"
          fill="none"
          stroke="currentColor"
          stroke-width="2"/>
      </svg>
    </span>
  `,
  });
  handleClickSlick(rules[0]);
  updateTextTotal(rules[0]);
  window.handleChangeValueQuantity = handleChangeValueQuantity;
};
window.orichiRun2 = orichiRun2;